const stats = (state = {
  pageViews: 5000000,
  uniqueVisitors: 800000,
  impressions: 2700000
}, action) => {
  switch(action.type) {
    case 'UPDATE_STATS':
      // console.log(action.stats)
      return action.stats
      // return state.map( stat => {
      //   if( stat.id === action.stat.id )
      //     return action.stat
      //   return stat
      // })
    default:
      return state;
  }
}

export default stats;



// WEBPACK FOOTER //
// ./src/reducers/stats.js